import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { UserService } from './user.service';
import {
  ArchitectureDetails, IAddSampleFinishCategoryBody, IArchitectureCategoryBody, IArchitectureDetails, IArchitectureDetailsBody,
  IArchitectureSubCategoryBody,
  IBroadcastMessage,
  IBroadcastMessageBody,
  ICategoryData, IErrorList, IOutageSchedule, IOutageScheduleBody, IPromoCode, IPromoCodeBody, ISampleFinish, ITestCategoryBody, INewsAdmin, ITestReportBody, ITestReportGrid, IItemCatalog, IItemCatalogBody, IImageAdmin, IImageAdminBody, IBannerImageBody, IMechanicSchoolAdminBody, ISurveyAdmin, IPrductMapping, IPrductCategory, IProductConfig, IPrductConfiguration, IPrductSubCategory
  , BaseResponse,
  IBBProductHierarchies,
  IBBPrductCategory,
  IBBProductSubCategory,
  IBBPrductConfiguration
} from '../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  //#region constructor
  constructor(private httpClient: HttpClient,
    private userService: UserService) { }
  //#endregions
  //#region Api EndPoints

  private SAMPLE_FINISH: Array<ISampleFinish> = [];
  public get sampleFinish(): Array<ISampleFinish> {
    if (!this.SAMPLE_FINISH) {
      this.SAMPLE_FINISH = [];
    }
    return this.SAMPLE_FINISH;
  }
  public set sampleFinish(sampleFinish: Array<ISampleFinish>) {
    this.SAMPLE_FINISH = sampleFinish;
  }
  public getSampleFinishes(): Observable<Array<ISampleFinish>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_SAMPLE_FINISHES}`;
    // return ApiService.genericObservableGet(this.httpClient, endPoint);
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleFinish) => { this.sampleFinish = sampleFinish }));


  }
  public AddSampleFinishCategory(body: IAddSampleFinishCategoryBody): Observable<Array<ISampleFinish>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_SAMPLE_FINISH_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleFinish) => this.updateSampleFinishData(body)));
  }

  public AddSampleFinishSubCategory(body: IAddSampleFinishCategoryBody): Observable<Array<ISampleFinish>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_SAMPLE_FINISH_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleFinish) => this.updateSampleFinishData(body)));
  }


  public updateSampleFinishData(sampleFinish: IAddSampleFinishCategoryBody) {
    //debugger;
    if (sampleFinish) {
      const indextemp = this.sampleFinish.findIndex(r => r.finishSampleLevel1key === sampleFinish.finishSampleLevel1key);
      const temp = this.sampleFinish.find(r => r.finishSampleLevel1key === sampleFinish.finishSampleLevel1key);
      if (temp) {
        this.SAMPLE_FINISH.splice(indextemp, 1, sampleFinish);
      } else {
        this.SAMPLE_FINISH.push(sampleFinish);
      }
    }
  }

  public DeleteSampleFinishSubCategory(body: IAddSampleFinishCategoryBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_SAMPLE_FINISH_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
        //tap((sampleFinish) => this.updateSampleFinishData(body))
      );
  }

  

  //#endregions

  //#region marketing admin Submittal package--architecture details
  public getArchitectureDetails(): Observable<Array<IArchitectureDetails>> {
    // const customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_ARCHITECTURE_DETAILS}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((architectureDetails) => { this.ARCHITECTURE_DETAILS = architectureDetails })
      );

  }
  public getCategory(): Observable<Array<ICategoryData>> {
    // const customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_CATEGORY}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );

  }

  public saveArchitectureCategory(data: IArchitectureDetailsBody): Observable<Array<ArchitectureDetails>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_ARCHITECTURE_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((architectureDetail) => this.updateArchitectureDetailsData(data))
      );

  }
  public saveArchitectureDetails(data: IArchitectureDetailsBody): Observable<Array<ArchitectureDetails>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_ARCHITECTURE_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((architectureDetail) => this.updateArchitectureDetailsData(data))
      );

  }

  public deleteArchitectureDetails(data: IArchitectureDetailsBody): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_ARCHITECTURE_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
        //tap((architectureDetail) => this.updateArchitectureDetailsData(data))// fix for admin issue delete functionality
      );

  }
  //#region Architecture details Cache & Operations
  private ARCHITECTURE_DETAILS: Array<IArchitectureDetails> = [];
  public get architectureDetails(): Array<IArchitectureDetails> {
    if (!this.ARCHITECTURE_DETAILS) {
      this.ARCHITECTURE_DETAILS = [];
    }
    return this.ARCHITECTURE_DETAILS;
  }
  public set architectureDetails(architectureDetails: Array<IArchitectureDetails>) {
    this.ARCHITECTURE_DETAILS = architectureDetails;
  }
  public updateArchitectureDetailsData(architectureDetails: IArchitectureDetailsBody) {
    //debugger;
    if (architectureDetails) {
      const indextemp = this.architectureDetails.findIndex(r => r.categoryId === architectureDetails.categoryId);
      const temp = this.architectureDetails.find(r => r.categoryId === architectureDetails.categoryId);
      if (temp) {
        this.ARCHITECTURE_DETAILS.splice(indextemp, 1, architectureDetails);
      } else {
        this.ARCHITECTURE_DETAILS.push(architectureDetails);
      }
    }
  }
  //#endregion
  //#endregion
  //#region marketing admin submittal package test report
  public getTestReport(): Observable<Array<ITestReportGrid>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_TEST_REPORT}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((testReportData) => { this.testReportData = testReportData })); //Need to change this.testReportData to this.TEST_REPORT
  }
  public saveTestSubCategory(data: ITestReportBody): Observable<Array<any>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_TEST_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((testReportData) => this.updateTestReportData(data)));
  }
  public saveTestCategory(data: ITestCategoryBody): Observable<Array<any>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_TEST_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((testReportData) => this.updateTestReportData(data)));
  }
  public saveTestReport(data: ITestReportBody): Observable<Array<ITestReportGrid>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_TEST_REPORT}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((testReportData) => this.updateTestReportData(data)));
  }

  public deleteTestReport(data: ITestReportBody): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_TEST_REPORT}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      //tap((testReportData) => this.updateTestReportData(data))
    );
  }

  //#region Architecture details Cache & Operations
  private TEST_REPORT: Array<ITestReportGrid> = [];
  public get testReportData(): Array<ITestReportGrid> {
    if (!this.TEST_REPORT) {
      this.TEST_REPORT = [];
    }
    return this.TEST_REPORT;
  }
  public set testReportData(testReport: Array<ITestReportGrid>) {
    this.TEST_REPORT = testReport;
  }
  public updateTestReportData(testReport: ITestReportBody) {
    if (testReport) {
      const indextemp = this.testReportData.findIndex(r => r.subCategoryId === testReport.subCategoryId);
      const temp = this.testReportData.find(r => r.subCategoryId === testReport.subCategoryId);
      if (temp) {
        this.TEST_REPORT.splice(indextemp, 1, testReport);
      } else {
        this.TEST_REPORT.push(testReport);
      }
    }
  }
  //#endregion
  //#endregion
  //#region BroadCast Message
  public getBroadcastMessage(): Observable<Array<IBroadcastMessage>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_BROADCAST_MESSAGE}`;
    // return ApiService.genericObservableGet(this.httpClient, endPoint);
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
    //.pipe(tap((sampleFinish) => { this.sampleFinish = sampleFinish }));


  }
  public AddBroadcastMessage(body: IBroadcastMessageBody): Observable<Array<IBroadcastMessage>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_BROADCAST_MESSAGE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
    //.pipe(tap((sampleFinish) => this.updateSampleFinishData(body)));
  }

  public deleteBroadcastMessage(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_BROADCAST_MESSAGE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
    //.pipe(tap((sampleFinish) => this.updateSampleFinishData(body)));
  }
  //#endregion

  //#endregion
  //#region Item Catalog
  private ITEM_CATALOG: Array<IItemCatalog> = [];
  public get itemCatalogData(): Array<IItemCatalog> {
    if (!this.ITEM_CATALOG) {
      this.ITEM_CATALOG = [];
    }
    return this.ITEM_CATALOG;
  }
  public set itemCatalogData(itemCatalog: Array<IItemCatalog>) {
    this.ITEM_CATALOG = itemCatalog;
  }
  public getItemCatalog(): Observable<Array<IItemCatalog>> {
    const endPoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.GET_ITEM_CATALOG}`;
    // return ApiService.genericObservableGet(this.httpClient, endPoint);
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((items) => { this.itemCatalogData = items })
      );

  }
  public AddItemCatalog(body: IItemCatalogBody): Observable<Array<IItemCatalog>> {
    //debugger;
    const endPoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.SAVE_ITEM_CATALOG}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );
    //.pipe(tap((sampleFinish) => this.updateSampleFinishData(body)));
  }
  //#endregion

  //#region error List
  public getErrorList(): Observable<Array<IErrorList>> {
    const endPoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.GET_ERROR_LIST}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );

  }

  //#endregion
  //#region promo code
  public getPromoCode(): Observable<Array<IPromoCode>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_PROMO_CODE}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((promoCodes) => { this.promoCodes = promoCodes }));
  }
  public savePromoCode(data: IPromoCodeBody): Observable<Array<IPromoCodeBody>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_PROMO_CODE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((promoCodes) => this.updatePromoCodeData(data)));
  }

  public deletePromoCode(data: IPromoCodeBody): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_PROMO_CODE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        //tap((promoCodes) => this.updatePromoCodeData(data))
      );
  }


  //#region Promo Code Cache & Operations
  private PROMO_CODE: Array<IPromoCode> = [];
  public get promoCodes(): Array<IPromoCode> {
    if (!this.PROMO_CODE) {
      this.PROMO_CODE = [];
    }
    return this.PROMO_CODE;
  }
  public set promoCodes(promoCodes: Array<IPromoCode>) {
    this.PROMO_CODE = promoCodes;
  }
  public updatePromoCodeData(promoCodes: IPromoCodeBody) {
    if (promoCodes) {
      const indextemp = this.promoCodes.findIndex(r => r.promoCodeId === promoCodes.promoCodeId);
      const temp = this.promoCodes.find(r => r.promoCodeId === promoCodes.promoCodeId);
      if (temp) {
        this.PROMO_CODE.splice(indextemp, 1, promoCodes);
      } else {
        this.PROMO_CODE.push(promoCodes);
      }
    }
  }
  //#endregion
  //#endregion
  //#region Outage Schedule
  public getOutageSchedule(): Observable<Array<IOutageSchedule>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_OUTAGE_SCHEDULE}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((outageSchedule) => { this.OUTAGE_SCHEDULE = outageSchedule }));
  }
  public saveOutageSchedule(data: IOutageScheduleBody): Observable<Array<IOutageSchedule>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_OUTAGE_SCHEDULE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((testReportData) => this.updateOutageSchedule(data)));
  }

  public deleteOutageSchedule(data: IOutageScheduleBody): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_OUTAGE_SCHEDULE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        //tap((testReportData) => this.updateOutageSchedule(data))
      );
  }
  //#region  Outage Schedule Cache & Operations
  private OUTAGE_SCHEDULE: Array<IOutageSchedule> = [];
  public get outageSchedule(): Array<IOutageSchedule> {
    if (!this.OUTAGE_SCHEDULE) {
      this.OUTAGE_SCHEDULE = [];
    }
    return this.OUTAGE_SCHEDULE;
  }
  public set outageSchedule(outageSchedule: Array<IOutageSchedule>) {
    this.OUTAGE_SCHEDULE = outageSchedule;
  }
  public updateOutageSchedule(outageSchedule: IOutageSchedule) {
    if (outageSchedule) {
      const indextemp = this.outageSchedule.findIndex(r => r.outageScheduleId === outageSchedule.outageScheduleId);
      const temp = this.outageSchedule.find(r => r.outageScheduleId === outageSchedule.outageScheduleId);
      if (temp) {
        this.OUTAGE_SCHEDULE.splice(indextemp, 1, outageSchedule);
      } else {
        this.OUTAGE_SCHEDULE.push(outageSchedule);
      }
    }
  }
  //#endregion

  //#region Images Admin  
  public GetImages(): Observable<Array<IImageAdmin>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_IMAGES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((imageAdminData) => { this.imageAdminData = imageAdminData }));
  }
  //#region  Outage Schedule Cache & Operations
  private IMAGE_ADMIN: Array<IImageAdmin> = [];
  public get imageAdminData(): Array<IImageAdmin> {
    if (!this.IMAGE_ADMIN) {
      this.IMAGE_ADMIN = [];
    }
    return this.IMAGE_ADMIN;
  }
  public set imageAdminData(imageAdminData: Array<IImageAdmin>) {
    this.IMAGE_ADMIN = imageAdminData;
  }
  public SaveImages(body: IImageAdminBody): Observable<Array<IImageAdmin>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_IMAGES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((imageAdminData) => this.updateImageAdminData(body)));
  }

  public updateImageAdminData(imageAdminData: IImageAdminBody) {
    //debugger;
    if (imageAdminData) {
      const indextemp = this.imageAdminData.findIndex(r => r.imageId === imageAdminData.imageId);
      const temp = this.imageAdminData.find(r => r.imageId === imageAdminData.imageId);
      if (temp) {
        this.IMAGE_ADMIN.splice(indextemp, 1, imageAdminData);
      } else {
        this.IMAGE_ADMIN.push(imageAdminData);
      }
    }
  }

  public DeleteImages(body: IImageAdminBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_IMAGES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
        //tap((imageAdminData) => this.updateImageAdminData(body))
      );
  }

  //#endregion
  //#endregion

  //#endregion
  //#region home banner
  public GetBannerImages(body: IBannerImageBody): Observable<Array<any>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_BANNER_IMAGES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );
  }
  //#endregion
  //#region Customer spcific school admin
  public getTrainingPagesDescription(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_TRAINING_PAGES_DESCRIPTION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public saveTrainingPagesDescription(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_TRAINING_PAGES_DESCRIPTION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region mechanic school admin

  public saveMechanicsSchoolDetails(body: IMechanicSchoolAdminBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_MECHANICS_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public deleteMechanicsLocation(locationId: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_MECHANICS_SCHOOL_LOCATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, locationId).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region module school admin

  public saveModuleSchoolDetails(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_MODULES_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public deleteModuleSchoolModule(moduleId: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_MODULES_SCHOOL_MODULE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, moduleId).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public deleteModuleSchoolLocation(locationId: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_MODULES_SCHOOL_LOCATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, locationId).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion

  //#region Survey
  public getSurveyDetails(body): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_USER_SURVEY_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((survey) => { this.surveyQuestions = survey }));
  }
  public saveSurveyDetails(data: any): Observable<Array<ISurveyAdmin>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_SURVEY_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((survey) => this.updateSurveyData(survey)));
  }

  public deleteSurveyDetails(data: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_SURVEY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
       // tap((survey) => this.updateSurveyData(survey))
      );
  }


  public saveSurveyEntries(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_SURVEY_ENTRY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#region Survey Cache & Operations
  private SURVEY: Array<ISurveyAdmin> = [];
  public get surveyQuestions(): Array<ISurveyAdmin> {
    if (!this.SURVEY) {
      this.SURVEY = [];
    }
    return this.SURVEY;
  }
  public set surveyQuestions(survey: Array<ISurveyAdmin>) {
    this.SURVEY = survey;
  }
  public updateSurveyData(survey: ISurveyAdmin) {
    if (survey) {
      const indextemp = this.surveyQuestions.findIndex(r => r.surveyId === survey.surveyId);
      const temp = this.surveyQuestions.find(r => r.surveyId === survey.surveyId);
      if (temp) {
        this.SURVEY.splice(indextemp, 1, survey);
      } else {
        this.SURVEY.push(survey);
      }
    }
  }
  //#endregion
  //#endregion

  //#region Product Category
  public saveProductCategory(data: any): Observable<IBBPrductCategory> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_PRODUCT_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => {
          let productCategoryData: any; productCategoryData = response.data;          
          var tempImageUrl = '';
          tempImageUrl = productCategoryData.imageUrl;
          productCategoryData.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
          return productCategoryData;
        })
      );
  }

  //#endregion


  //#region ProductMapping
  public getProductMapping(): Observable<IBBProductHierarchies> {
    const endPoint = '/Admin/GetBBProductHierarchy';//`${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_PRODUCT_MAPPING}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response) => this.changeImageUrlToDisplay_1(response.data)),       
        tap((productMappingData) => {
          //this.productMappingData = productMappingData
        })
      );
  }

  changeImageUrlToDisplay_1(ph: IBBProductHierarchies) {  
    if (ph) {
      if (ph.categories) {
        ph.categories.forEach((el, i) => {
          el.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${el.imageUrl}`;
        });
      }
      if (ph.subCats) {
        ph.subCats.forEach((el, i) => {
          el.productImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${el.productImageUrl}`;
        })
      }
      if (ph.configs) {
        ph.configs.forEach((el, i) => {
          el.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${el.imageUrl}`;
        })
      }
    }
    return ph;
  }

  public getProductCategory(): Observable<Array<IPrductCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_PRODUCT_CATEGORY}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => this.changeImageUrlToDisplayCategory(response.data)
          //  map((productCategoryData) => this.changeImageUrlToDisplayCategory(productCategoryData))
        ),
        tap((productCategoryData) => { this.productCategoryData = productCategoryData })
      );
  }
  private PRODUCT_MAPPING: Array<IPrductMapping> = [];
  private PRODUCT_CATEGORY: Array<IPrductCategory> = [];
  public get productMappingData(): Array<IPrductMapping> {
    if (!this.PRODUCT_MAPPING) {
      this.PRODUCT_MAPPING = [];
    }
    return this.PRODUCT_MAPPING;
  }
  public set productMappingData(productMapping: Array<IPrductMapping>) {
    this.PRODUCT_MAPPING = productMapping;
  }
  public get productCategoryData(): Array<IPrductCategory> {
    if (!this.PRODUCT_CATEGORY) {
      this.PRODUCT_CATEGORY = [];
    }
    return this.PRODUCT_CATEGORY;
  }
  public set productCategoryData(productCategory: Array<IPrductCategory>) {
    this.PRODUCT_CATEGORY = productCategory;
  }
  private changeImageUrlToDisplay(productMapping: IPrductMapping[]) {
    if (productMapping) {
      // if (this.imageUrl) {
      productMapping.forEach((item, index) => {
        var tempImageUrl = '';
        tempImageUrl = item.categoryImageUrl;
        item.categoryImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
        tempImageUrl = item.subCategoryImageUrl;
        item.subCategoryImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
        tempImageUrl = item.configImageUrl;
        item.configImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
      })
      // }
    }
    return productMapping;
  }
  private changeImageUrlToDisplayCategory(productCategory: IPrductCategory[]) {
    if (productCategory) {
      // if (this.imageUrl) {
      productCategory.forEach((item, index) => {
        var tempImageUrl = '';
        tempImageUrl = item.imageUrl;
        item.imageUrl = `../assets/images/${tempImageUrl}`;
      })
      // }
    }
    return productCategory;
  }

  public saveProductConfiguration(data: any): Observable<IBBPrductConfiguration> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_PRODUCT_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => {
          let productConfigData: any; productConfigData = response.data;
          // map((productConfigData) => {
          var tempImageUrl = '';
          tempImageUrl = productConfigData.imageUrl;
          productConfigData.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
          tempImageUrl = productConfigData.subCatImageUrl;
          productConfigData.subCatImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
          tempImageUrl = productConfigData.catImageUrl;
          productConfigData.catImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
          return productConfigData;
        })
      );
  }
  public saveProductSubCategory(data): Observable<IBBProductSubCategory> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_PRODUCT_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { throw (err); }),
        map((response: BaseResponse) => {
          let productSubCatData: any; productSubCatData = response.data;
          // map((productSubCatData) => {
          var tempImageUrl = '';
          tempImageUrl = productSubCatData.productImageUrl;
          productSubCatData.productImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`;
          //tempImageUrl = productSubCatData.categoryImageUrl;
          //productSubCatData.categoryImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
          return productSubCatData;
        })
      );
  }
  //#endregion
  //#region news admin 
  public getNewsAdminDetails(body): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_NEWS_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((survey) => { this.newsDetails = survey })
      );
  }
  public saveNewsDetails(data: any): Observable<Array<INewsAdmin>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_NEWS_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((news) => this.updateNewsAdminData(news)));
  }
  //public saveNewsDetails(data: any): Observable<Array<INewsAdmin>> {
  //  const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_NEWS_DETAILS}`;
  //  return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
  //    .pipe(tap((news) => this.updateNewsAdminData(news)));
  //}
  public updateNewsDetails(data: any): Observable<Array<INewsAdmin>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.UPDATE_NEWS_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((news) => this.updateNewsAdminData(news)));
  }
  //#region Survey Cache & Operations
  private NEWS: Array<INewsAdmin> = [];
  public get newsDetails(): Array<INewsAdmin> {
    if (!this.NEWS) {
      this.NEWS = [];
    }
    return this.NEWS;
  }
  public set newsDetails(news: Array<INewsAdmin>) {
    this.NEWS = news;
  }
  public updateNewsAdminData(news: INewsAdmin) {
    if (news) {
      const indextemp = this.newsDetails.findIndex(r => r.docID === news.docID);
      const temp = this.newsDetails.find(r => r.docID === news.docID);
      if (temp) {
        this.NEWS.splice(indextemp, 1, news);
      } else {
        this.NEWS.push(news);
      }
    }
  }

  public deleteNewsDetails(data: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_NEWS_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        //tap((news) => this.updateNewsAdminData(news))
      );
  }
  //#endregion
  //#endregion
}
